<script setup lang="ts">
import { MenuSection } from '~/lib/services/content/footer/footer.dtos'

defineProps<{ block: MenuSection[] }>()

const isMobile = inject('isMobile')
</script>

<template>
  <details v-for="footerItem in block" :key="footerItem.id" class="relative" :open="!isMobile">
    <summary
      class="flex cursor-pointer items-center gap-2 font-bold md:cursor-auto"
      @click="!isMobile ? $event.preventDefault() : null"
    >
      <span class="text-lg font-bold leading-6 tracking-[-0.15px]">{{ footerItem.title }}</span>
    </summary>
    <section class="mt-6 md:mt-8 md:text-left">
      <ul class="flex flex-col gap-2 md:gap-4">
        <li v-for="(link, index) in footerItem.linkPages" :key="index">
          <SimpleLink v-if="link" :link="link">
            <span v-if="link?.icon === null" class="text-sm leading-4 tracking-[-0.15px]">
              {{ link?.title }}
            </span>
            <img v-else :src="link?.icon?.url" :alt="link?.title !== null ? link?.title : ''" />
          </SimpleLink>
        </li>
      </ul>
    </section>
  </details>
</template>

<style scoped>
summary::after {
  @apply mt-2 content-[url('/images/icons/arrowDown.svg')]  md:hidden;
}

details[open] > summary::after {
  @apply mb-1 mt-0 rotate-180;
}
</style>
